var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export const ContentTitle = styled.div.withConfig({
  displayName: "TopicContents__ContentTitle",
  componentId: "sc-1d8cfks-0"
})(["margin-bottom:18px;", ";font-weight:600;color:", ";"], getFont(0, 'compact'), _ref => {
  let {
    theme
  } = _ref;
  return theme.secondaryColor;
});
export const Content = styled.div.withConfig({
  displayName: "TopicContents__Content",
  componentId: "sc-1d8cfks-1"
})(["display:flex;align-items:", ";margin-bottom:24px;a{color:currentColor;&:hover{color:", ";}}h4{padding-bottom:3px;", ";font-weight:700;}"], _ref2 => {
  let {
    align
  } = _ref2;
  return align ? align : 'flex-start';
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.linkColor;
}, getFont(0, 'compact'));
export const ContentInfo = styled.div.withConfig({
  displayName: "TopicContents__ContentInfo",
  componentId: "sc-1d8cfks-2"
})(["flex:1;padding-right:12px;h4{padding-bottom:0;}"]);
export const Meta = styled.div.withConfig({
  displayName: "TopicContents__Meta",
  componentId: "sc-1d8cfks-3"
})(["display:flex;align-items:center;flex-wrap:wrap;", ";", ";", " color:", ";strong,span{margin-right:6px;}"], getFont(-1, 'compact'), _ref4 => {
  let {
    padding
  } = _ref4;
  return padding && "padding: ".concat(padding);
}, fontSmoothing, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.fontL;
});
export const TopicContents = styled.div.withConfig({
  displayName: "TopicContents",
  componentId: "sc-1d8cfks-4"
})(["display:flex;padding:47px 0 37px;> div{width:100%;max-width:", "px;&:nth-child(1){margin-right:24px;}&:nth-child(2){margin-left:24px;margin-right:24px;}&:nth-child(3){margin-left:24px;margin-right:24px;", "}&:nth-child(4){margin-left:24px;margin-right:24px;", "}}"], grid(12 / 4), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: none;\n      "]))), maxMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        display: none;\n      "]))));
export const SendMessage = styled.a.withConfig({
  displayName: "TopicContents__SendMessage",
  componentId: "sc-1d8cfks-5"
})(["display:block;position:relative;flex-shrink:0;width:36px;height:36px;padding:8px;cursor:pointer;text-align:center;&:before{position:absolute;z-index:0;top:0;bottom:0;left:0;right:0;opacity:0;border-radius:36px;content:'';background:", ";transform:scale(0);transition-duration:0.15s;transition-property:transform,opacity;transition-timing-function:cubic-bezier(0.4,0,0.2,1);}svg{position:relative;z-index:1;color:", ";}&:hover{svg{color:", ";}&:before{opacity:1;transform:scale(1);}}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.uiL;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.fontLL;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.linkColor;
});